import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange, TemplateRef } from '@angular/core';

// tslint:disable-next-line:class-name
interface otherButton {
  text: string;
  type: string;
  sign: string;
}

@Component({
  selector: 'my-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.less'],
})
export class FeedbackComponent implements OnInit {
  /**
   * 是否显示组件
   */
  @Input() show: boolean = false;
  /**
   * 隐藏遮罩层
   */
  @Input() noMask: boolean = false;
  /**
   * 标题
   */
  @Input() title: string = '';
  /**
   * 是否显示关闭icon
   */
  @Input() closeIcon: boolean = true;
  /**
   * content 内容  templete
   */
  @Input() body: TemplateRef<any>;
  /**
   *  my-feedback组件样式
   */
  @Input() bodyStyle: object = {};
  /**
   * feedback整体深度
   */
  @Input() index: number = 1000;
  /**
   * 是否显示底部操作栏
   */
  @Input() showBottom: boolean = true;
  /**
   * 是否允许在执行确认操作时同时关闭组件
   */
  @Input() directClose: boolean = false;
  /**
   * 是否显示确认按钮
   * 默认true
   */
  @Input() showSure: boolean = true;
  /**
   * 确认按钮文本
   */
  @Input() sureText: string = '确 定';
  /**
   * 是否显示取消按钮
   * 默认true
   */
  @Input() showCancel: boolean = true;
  /**
   * 取消按钮文本
   */
  @Input() cancelText: string = '取 消';
  /**
   * 自定义按钮列表
   */
  @Input() otherButton: otherButton[] = [];
  /**
   * 确认按钮事件
   */
  @Output() sure = new EventEmitter();
  /**
   * 取消按钮点击事件
   */
  @Output() cancel = new EventEmitter();
  /**
   * 自定义按钮事件
   */
  @Output() other = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(change: SimpleChange): void {
  }

  /**
   * 取消事件
   */
  clickCancel(): void {
    if (this.directClose) {
      this.show = false;
    }
    this.cancel.emit({ event: 'cancel' });
  }

  clickSure(): void {
    if (this.directClose) {
      this.show = false;
    }
    this.sure.emit({ event: 'sure' });
  }

  /**
   * 点击自定义按钮
   * @param buttonElement
   */
  clickOther(buttonElement: string): void {
    this.other.emit({ event: buttonElement });
  }
}
